<div *ngFor="let rate of rateCampaign;let i = index">
    <div class="title-div title-div--bold">{{rate.name}}</div>

    <div class="px-0 py-4 grid md:grid-cols-3 gap-x-4 gap-y-4">

        <div *ngFor="let rt of rate.rates;let k = index">
            <label class="rate__label">{{rt.title}} <span class="rate__required">*</span></label>
            <div class="rate__stars" role="group" [attr.aria-label]="rt.title"
                (mouseleave)="rt.hover = null">
                <button *ngFor="let star of stars" type="button" class="rate__star"
                    [class.rate__star--on]="star <= shownRate(rt)"
                    [matTooltip]="levels[star]"
                    [attr.aria-label]="star + ' de 5: ' + levels[star]"
                    [attr.aria-pressed]="star === rt.value"
                    (mouseenter)="rt.hover = star"
                    (focus)="rt.hover = star"
                    (blur)="rt.hover = null"
                    (click)="setRate(rt, star)">
                    <mat-icon>{{ star <= shownRate(rt) ? 'star' : 'star_border' }}</mat-icon>
                </button>
                <span class="rate__level" *ngIf="shownRate(rt)">
                    {{ levels[shownRate(rt)] }}
                </span>
            </div>
            <div class="rate__error" *ngIf="!rt.value">Falta valoración</div>
        </div>
    </div>
</div>
<mat-divider></mat-divider>
<div class="title-div title-div--bold">Campaña</div>

<div  class="grid md:grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-2">
    <mat-form-field class="w-full" *ngFor="let cm of campaignValor;let in = index">
        <mat-label>{{cm.title}}</mat-label>
        <mat-select required [(ngModel)]="cm.value" #selectValor="ngModel"
            [errorStateMatcher]="mostrarSiempre" (ngModelChange)="onChange()">
            <mat-option *ngFor="let opt of cm.options" [value]="opt.id">{{opt.name}}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="selectValor.errors?.['required']">Falta seleccionar {{cm.title | lowercase}}</mat-error>
    </mat-form-field>
</div>
